export const Status = ["HOT", "WARM", "COLD", "STORE", "DONE"];
export const Results = ["BETTER", "GOOD", "NORMAL", "NEGATIVE"];
export const LeadStatus = ["DONE", "PROCESS", "PENDING", "PLAN PRESENTED", "POSTPONED"];
